import EmailIcon from '@mui/icons-material/Email'; // Added email icon
import {
  Box,
  Dialog,
  DialogContent,
  Link,
  TextField,
  Typography,
  useMediaQuery
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { CheckCircleIcon } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../common/button/commonButton';
import { APP_LINK } from '../../common/menu/menuItems/menuList';
import {
  ImageContainer,
  LoginContainer,
  LoginStyle,
  PageContainer,
  StyledContainer
} from '../../commonStyle/loginStyle';
import Logo from '../../image/logo.png';
import wardImage1 from '../../image/wardImage1.jpg';
import { authResetState, requestOtpRequest } from '../../redux/auth/authActions';

function ForgotPasswordPage() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError
  } = useForm()
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false)
  const { success, error, errorMessage } = useSelector(
    state => state.auth?.requestOtp || {}
  )
  const otpRequest = useSelector(
    state => state.auth?.requestOtp || {}
  )
  const onSubmit = data => {
    localStorage.setItem('email', data.email)
    dispatch(requestOtpRequest(data))
  }

  useEffect(() => {
    if (error) {
      if (errorMessage) {
        const errorLower = errorMessage.toLowerCase()
        if (errorLower.includes('email') || errorLower.includes('phone')) {
          setError('email', { type: 'manual', message: errorMessage })
        }
      } else {
        setError('email', {
          type: 'manual',
          message: 'An error occurred. Please try again.'
        })
      }

      setTimeout(() => {
        dispatch(authResetState())
      }, 1000)
    }
  }, [error, errorMessage, setError, dispatch])

  useEffect(() => {
    if (success) {
      setOpenSuccessDialog(true)
      const timer = setTimeout(() => {
        navigate(APP_LINK.OTPREQUEST)
        dispatch(authResetState())
      }, 2000)
      return () => clearTimeout(timer)
    }
  }, [success, navigate, dispatch])

  const handleCloseDialog = () => {
    setOpenSuccessDialog(false)
    navigate(APP_LINK.FORGOTPASSWORD)
  }

  return (
    <PageContainer>
      <StyledContainer>
        <ImageContainer>
          <Box sx={LoginStyle.boxOn}>
            <Box sx={LoginStyle.boxTwo}>
              <Box
                component='img'
                src={Logo}
                alt='XRay Logo'
                sx={LoginStyle.boxThree}
              />
              <Typography
                variant='h5'
                component='h1'
                sx={LoginStyle.typographyBold}
              >
                Government Hospital
              </Typography>
            </Box>
            {!isMobile && (
              <Box sx={LoginStyle.boxFore}>
                <Box
                  component='img'
                  src={wardImage1}
                  alt='Hospital facility'
                  sx={LoginStyle.boxFive}
                />
                <Typography variant='h3' sx={LoginStyle.typographyOne}>
                  " Pay Ward "
                </Typography>
              </Box>
            )}
          </Box>
        </ImageContainer>
        <LoginContainer elevation={0}>
          <Box sx={LoginStyle.boxSix}>
            <Typography
              variant={isMobile ? 'h5' : 'h4'}
              component='h1'
              sx={LoginStyle.typographyTwo}
            >
              Forgot Password
            </Typography>
            <Typography
              variant='body2'
              color='textSecondary'
              sx={LoginStyle.textSecondary}
            >
              Enter your email address below to receive a password reset link.
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Box sx={LoginStyle.formField}>
                <TextField
                  fullWidth
                  label="Email"
                  placeholder="Enter your email address"
                  type="text"
                  name="email"
                  startIcon={<EmailIcon />}
                  {...register('email', {
                    required: 'Email is required',
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: 'Please enter a valid email address'
                    }
                  })}
                  error={!!errors.email}
                  helperText={errors.email?.message}
                  size='small'
                  required={true}
                  style={{ marginBottom: '16px' }}
                />
              </Box>
              <Box sx={LoginStyle.rememberMeContainer}>
                <CustomButton
                  type='submit'
                  text='Submit'
                  variant='contained'
                  disableElevation
                  size='small'
                  disabled={otpRequest?.inProgress}
                  loading={otpRequest?.inProgress}
                />
              </Box>
            </form>
            <Box sx={LoginStyle.footerContainer}>
              <Typography variant='body2' color='textSecondary'>
                Remembered your password?{' '}
                <Link href='/' underline='none' sx={LoginStyle.signUpLink}>
                  Sign In
                </Link>
              </Typography>
            </Box>
          </Box>
        </LoginContainer>
      </StyledContainer>
      <Dialog
        open={openSuccessDialog}
        onClose={handleCloseDialog}
        aria-labelledby='login-success-dialog'
        PaperProps={{
          sx: {
            borderRadius: '8px',
            maxWidth: '500px',
            padding: '16px',
            textAlign: 'center'
          }
        }}
      >
        <DialogContent sx={{ textAlign: 'center', py: 2, width: '300px' }}>
          <CheckCircleIcon
            sx={{
              color: '#4CAF50',
              fontSize: 64,
              mb: 2
            }}
          />
          <Typography variant='h3' sx={{ fontWeight: 'bold' }}>
            OTP Send Successful!
          </Typography>
        </DialogContent>
      </Dialog>
    </PageContainer>
  )
}

export default ForgotPasswordPage